/**
 * @description 메세지 vuex 모듈 관련
 * @author 김원명, @date 2024-01-24
 */
const admMsgModule = {
    namespaced  : true,
    state       : {
        admMsg : {
            rooms       : [],
            messages    : [],
            roomId      : ''
        }
    },
    mutations : {
        setRooms(state, newRooms)
        {
            state.admMsg.rooms = newRooms;
        },
        setMessages(state, newMessages)
        {
            state.admMsg.messages = newMessages;
        },
        setRoomId(state, newRoomId)
        {
            state.admMsg.roomId = newRoomId;
        }
    }
};
  
export default admMsgModule;